import Alpine from "../alpine.js"

Alpine.data("tagFilter", () => ({
  filters: [],
  filter () {
    console.log(this.filters)

    let filterableNodes = document.querySelectorAll('[data-tag-target="true"]')

    if (this.filters.length === 0) {
      filterableNodes.forEach((node) => { node.classList.remove('hidden') })
    } else {
      filterableNodes.forEach((node) => {
        let tagNodes = node.querySelectorAll('[data-tag]')
        let includesFilteredTag = false
        tagNodes.forEach((tagNode) => {
          let tag = tagNode.dataset.tag
          if (this.filters.includes(tag)) {
            includesFilteredTag = true
          }
        })

        if (includesFilteredTag) {
          node.classList.remove('hidden')
        } else {
          node.classList.add('hidden')
        }
      })
    }
  },
  toggleFilter (tag) {
    let index = this.filters.indexOf(tag)

    if (index === -1) {
      this.filters.push(tag)
    } else {
      this.filters.splice(index, 1)
    }

    this.filter()
  }
}))
